export default {
  PAGE_SIZES: [ 50, 100, 200]
}



// WEBPACK FOOTER //
// ./src/components/Pagination/PageParam.js